export default __webpack_public_path__ + "static/media/workReassign.7ddda0cc.svg";